module.exports = __webpack_public_path__ + "img/mathrice-logo.32475f88.png";